import { useState, useEffect } from 'react';
import { BrandsAPI } from '../connections/Brands';

/**
 * Fetches the list of brands from /api/v1/brands once on mount.
 * US1984532: Called from ModernHome.js so brands are not re-fetched on every panel open.
 * @returns {{ brands: Array, loading: boolean, error: Error|null }}
 */
const useBrands = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    BrandsAPI.get()
      .then((result) => {
        if (!cancelled) setBrands(result.brands || []);
      })
      .catch((err) => {
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return { brands, loading, error };
};

export default useBrands;
